import { createQueryKeys } from '@lukemorales/query-key-factory';

/**
 * Query keys for Credits API calls
 *
 * To invalidate ALL credits queries, use: queries.credits._def
 */
export const credits = createQueryKeys('credits', {
	transactions: (servicesProviderId: string, year: number, month: number) => ({
		queryKey: [servicesProviderId, year, month],
	}),
});

/**
 * Query keys for Plan Details API calls
 *
 * To invalidate ALL planDetails queries, use: queries.planDetails._def
 */
export const planDetails = createQueryKeys('planDetails', {
	details: (servicesProviderId: string) => ({
		queryKey: [servicesProviderId],
	}),
});
